/**
 * How to use this? simple. add this mixin into the component your building, and then simply use 'this.localValue' as your value.
 * The parent component will be able to use the new component with simple v-model input
 */

export default {
	props: { value: { type: [String, Number, Boolean, Object, Array] } },
	data() {
		return {
			localValue: this.value,
		};
	},
	watch: {
		localValue: {
			handler(newV) {
				this.$emit('input', newV);
			},
			deep: true,
		},
		value: {
			handler(newV) {
				this.localValue = newV;
			},
			deep: true,
			immediate: true,
		},
	},
};
